import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getBusinessOpportunityDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  airportConsultancy: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.markup",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.markup",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      // validation: {},
    },
    // {
      //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   // validation: {},
    // },
    {
      fieldName: "Markup (ZH)",
      fieldValue: "data.markup",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      // validation: {},
    },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_next_page_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content Next Page Name (EN)",
//       validation: { required: "Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_ms_next_page_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter Next Page Name (MS)",
//       // validation: {},
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_zh_next_page_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter Next Page Name (ZH)",
//       // validation: {},
//     },
//     {
//       fieldName: "Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_next_page_link",
//       formType: "input",
//       label: "Next Page Link",
//       placeholder: "Enter content Next Page Link",
//       validation: { required: "Next Page Link is required",  validate: (value: string) => {
//   const trimmed = value.trim();
//   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
//   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
//     return "Looks like an external link. Please use an in-app page link, such as /example";
//   }
//   return true;
// }  },
//     },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   // validation: {},
    // },
  ],
  airportConsultancyPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  airportConsultancyNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content Next Page Name (EN)",
      validation: { required: "Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      // validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      // validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content Next Page Link",
      validation: { required: "Next Page Link is required",  validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
}  },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   // validation: {},
    // },
  ],
  airportPlaningAndDesign: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.items[0].body",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.items[0].body",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      // validation: {},
    },{
      fieldName: "Markup (ZH)",
      fieldValue: "data.items[0].body",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      // validation: {},
    },
  ],
  airportDevelopment: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.items[1].body",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.items[1].body",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      // validation: {},
    },
    {
      fieldName: "Markup (ZH)",
      fieldValue: "data.items[1].body",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      // validation: {},
    },
  ],
  airportOperationsAndAirportSystems: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.items[2].body",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.items[2].body",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      // validation: {},
    },{
      fieldName: "Markup (ZH)",
      fieldValue: "data.items[2].body",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      // validation: {},
    },
  ],
  overseasInvestments: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.items[3].body",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.items[3].body",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      // validation: {},
    },{
      fieldName: "Markup (ZH)",
      fieldValue: "data.items[3].body",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      // validation: {},
    },
  ],
  airlineIncentivesPageContent:[
    {
      fieldName: "Description (EN)",
      fieldValue: "data.description",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "data.description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: {},
    },
    // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
      //   name: "field_content_ms_next_page_link",
      //   formType: "input",
      //   label: "Next Page Link (MS)",
      //   placeholder: "Enter Next Page Link (MS)",
      //   // validation: {},
      // },
      {
        fieldName: "Description (ZH)",
        fieldValue: "data.description",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_zh_description",
        formType: "richText",
        label: "Description (ZH)",
        placeholder: "Enter Description (ZH)",
        // validation: {},
      },
//       {
//         fieldName: "Next Page Name (EN)",
//         fieldValue: "data.nextPage.name",
//         parseField: "field_content_english",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_english_next_page_name",
//         formType: "input",
//         label: "Next Page Name (EN)",
//         placeholder: "Enter Next Page Name (EN)",
//         validation: { required: "Next Page Name (EN) is required" },
//       },
//       {
//         fieldName: "Next Page Name (MS)",
//         fieldValue: "data.nextPage.name",
//         parseField: "field_content_malay",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_ms_next_page_name",
//         formType: "input",
//         label: "Next Page Name (MS)",
//         placeholder: "Enter Next Page Name (MS)",
//         // validation: {},
//       },
//       {
//         fieldName: "Next Page Name (ZH)",
//         fieldValue: "data.nextPage.name",
//         parseField: "field_content_mandarin",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_zh_next_page_name",
//         formType: "input",
//         label: "Next Page Name (ZH)",
//         placeholder: "Enter Next Page Name (ZH)",
//         // validation: {},
//       },
//       {
//         fieldName: "Next Page Link",
//         fieldValue: "data.nextPage.link",
//         parseField: "field_content_english",
//         className: "col-span-6",
//         type: "content",
//         name: "field_content_english_next_page_link",
//         formType: "input",
//         label: "Next Page Link",
//         placeholder: "Enter content Next Page Link",
//         validation: { required: "Next Page Link is required",  validate: (value: string) => {
//   const trimmed = value.trim();
//   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
//   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
//     return "Looks like an external link. Please use an in-app page link, such as /example";
//   }
//   return true;
// }  },
//       },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   // validation: {},
    // },
  ],
  airlineIncentivesNextPage:[
      {
        fieldName: "Next Page Name (EN)",
        fieldValue: "data.nextPage.name",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_next_page_name",
        formType: "input",
        label: "Next Page Name (EN)",
        placeholder: "Enter Next Page Name (EN)",
        validation: { required: "Next Page Name (EN) is required" },
      },
      {
        fieldName: "Next Page Name (MS)",
        fieldValue: "data.nextPage.name",
        parseField: "field_content_malay",
        className: "col-span-6",
        type: "content",
        name: "field_content_ms_next_page_name",
        formType: "input",
        label: "Next Page Name (MS)",
        placeholder: "Enter Next Page Name (MS)",
        // validation: {},
      },
      {
        fieldName: "Next Page Name (ZH)",
        fieldValue: "data.nextPage.name",
        parseField: "field_content_mandarin",
        className: "col-span-6",
        type: "content",
        name: "field_content_zh_next_page_name",
        formType: "input",
        label: "Next Page Name (ZH)",
        placeholder: "Enter Next Page Name (ZH)",
        // validation: {},
      },
      {
        fieldName: "Next Page Link",
        fieldValue: "data.nextPage.link",
        parseField: "field_content_english",
        className: "col-span-6",
        type: "content",
        name: "field_content_english_next_page_link",
        formType: "input",
        label: "Next Page Link",
        placeholder: "Enter content Next Page Link",
        validation: { required: "Next Page Link is required",  validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
}  },
      },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   // validation: {},
    // },
  ],
 airlineIncentivesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  airlineServicesFacilitiesNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
  commercialLeasingOpportunitiesList: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_leasing_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_leasing_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_tender_category_ms",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_tender_category_zh",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "OMD Number (EN)",
      fieldValue: "field_omd_number_en",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_en",
      formType: "input",
      label: "OMD Number (EN)",
      placeholder: "Enter OMD Number (EN)",
      validation: { required: "OMD Number (EN) is required" },
    },
    {
      fieldName: "OMD Number (MS)",
      fieldValue: "field_omd_number_ms",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_ms",
      formType: "input",
      label: "OMD Number (MS)",
      placeholder: "Enter OMD Number (MS)",
      // validation: { required: "OMD Number (MS) is required" },
    },
    {
      fieldName: "OMD Number (ZH)",
      fieldValue: "field_omd_number_zh",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_zh",
      formType: "input",
      label: "OMD Number (ZH)",
      placeholder: "Enter OMD Number (ZH)",
      // validation: { required: "OMD Number (ZH) is required" },
    },
    {
      fieldName: "Airport (EN)",
      fieldValue: "field_airport_en",
      className: "col-span-6",
      type: "text",
      name: "field_airport_en",
      formType: "input",
      label: "Airport (EN)",
      placeholder: "Enter Airport (EN)",
      validation: { required: "Airport (EN) is required" },
    },
    {
      fieldName: "Airport (MS)",
      fieldValue: "field_airport_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airport_ms",
      formType: "input",
      label: "Airport (MS)",
      placeholder: "Enter Airport (MS)",
      // validation: { required: "Airport (MS) is required" },
    },
    {
      fieldName: "Airport (ZH)",
      fieldValue: "field_airport_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airport_zh",
      formType: "input",
      label: "Airport (ZH)",
      placeholder: "Enter Airport (ZH)",
      // validation: { required: "Airport (ZH) is required" },
    },
    {
      fieldName: "Leasing (EN)",
      fieldValue: "field_leasing_en",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_en",
      formType: "input",
      label: "Leasing (EN)",
      placeholder: "Enter Leasing (EN)",
      validation: { required: "Leasing (EN) is required" },
    },
    {
      fieldName: "Leasing (MS)",
      fieldValue: "field_leasing_ms",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_ms",
      formType: "input",
      label: "Leasing (MS)",
      placeholder: "Enter Leasing (MS)",
      // validation: { required: "Leasing (MS) is required" },
    },
    {
      fieldName: "Leasing (ZH)",
      fieldValue: "field_leasing_zh",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_zh",
      formType: "input",
      label: "Leasing (ZH)",
      placeholder: "Enter Leasing (ZH)",
      // validation: { required: "Leasing (ZH) is required" },
    },
    {
      fieldName: "Tenancy Link (EN)",
      fieldValue: "field_tenancy_link_en",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_en",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (EN)",
      placeholder: "Enter Tenancy Link (EN)",
      validation: { required: "Tenancy Link (EN) is required" },
    },
    {
      fieldName: "Tenancy Link (MS)",
      fieldValue: "field_tenancy_link_ms",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_ms",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (MS)",
      placeholder: "Enter Tenancy Link (MS)",
      // validation: { required: "Tenancy Link (MS) is required" },
    },
    {
      fieldName: "Tenancy Link (ZH)",
      fieldValue: "field_tenancy_link_zh",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_zh",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (ZH)",
      placeholder: "Enter Tenancy Link (ZH)",
      // validation: { required: "Tenancy Link (ZH) is required" },
    },
    {
      fieldName: "Tender Priority (EN)",
      fieldValue: "field_tender_priority",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority",
      formType: "select",
      label: "Tender Priority (EN)",
      placeholder: "Enter Tender Priority (EN)",
      validation: { required: "Tender Priority (EN) is required" },
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
    },
    {
      fieldName: "Tender Priority (MS)",
      fieldValue: "field_tender_priority_ms",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_ms",
      formType: "select",
      label: "Tender Priority (MS)",
      placeholder: "Enter Tender Priority (MS)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (MS) is required" },
    },
    {
      fieldName: "Tender Priority (ZH)",
      fieldValue: "field_tender_priority_zh",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_zh",
      formType: "select",
      label: "Tender Priority (ZH)",
      placeholder: "Enter Tender Priority (ZH)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (ZH) is required" },
    },
    {
      fieldName: "Opening Date",
      fieldValue: "field_opening_date",
      className: "col-span-6",
      type: "text",
      name: "field_opening_date",
      formType: "dateTime",
      label: "Opening Date",
      placeholder: "Select Opening Date",
      validation: { required: "Opening Date is required" },
    },
    {
      fieldName: "Closing Date",
      fieldValue: "field_closing_date",
      className: "col-span-6",
      type: "text",
      name: "field_closing_date",
      formType: "dateTime",
      label: "Closing Date",
      placeholder: "Select Closing Date",
      validation: { required: "Closing Date is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
    // {
    //   fieldName: "Page Name (EN)",
    //   fieldValue: "field_pagename_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_pagename_en",
    //   formType: "input",
    //   label: "Page Name (EN)",
    //   placeholder: "Enter Page Name (EN)",
    //   validation: { required: "Page Name (EN) is required" },
    // },
   
  ],
  retailOutletList: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_leasing_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_leasing_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_tender_category_ms",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_tender_category_zh",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "OMD Number (EN)",
      fieldValue: "field_omd_number_en",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_en",
      formType: "input",
      label: "OMD Number (EN)",
      placeholder: "Enter OMD Number (EN)",
      validation: { required: "OMD Number (EN) is required" },
    },
    {
      fieldName: "OMD Number (MS)",
      fieldValue: "field_omd_number_ms",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_ms",
      formType: "input",
      label: "OMD Number (MS)",
      placeholder: "Enter OMD Number (MS)",
      // validation: { required: "OMD Number (MS) is required" },
    },
    {
      fieldName: "OMD Number (ZH)",
      fieldValue: "field_omd_number_zh",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_zh",
      formType: "input",
      label: "OMD Number (ZH)",
      placeholder: "Enter OMD Number (ZH)",
      // validation: { required: "OMD Number (ZH) is required" },
    },
    {
      fieldName: "Airport (EN)",
      fieldValue: "field_airport_en",
      className: "col-span-6",
      type: "text",
      name: "field_airport_en",
      formType: "input",
      label: "Airport (EN)",
      placeholder: "Enter Airport (EN)",
      validation: { required: "Airport (EN) is required" },
    },
    {
      fieldName: "Airport (MS)",
      fieldValue: "field_airport_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airport_ms",
      formType: "input",
      label: "Airport (MS)",
      placeholder: "Enter Airport (MS)",
      // validation: { required: "Airport (MS) is required" },
    },
    {
      fieldName: "Airport (ZH)",
      fieldValue: "field_airport_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airport_zh",
      formType: "input",
      label: "Airport (ZH)",
      placeholder: "Enter Airport (ZH)",
      // validation: { required: "Airport (ZH) is required" },
    },
    {
      fieldName: "Leasing (EN)",
      fieldValue: "field_leasing_en",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_en",
      formType: "input",
      label: "Leasing (EN)",
      placeholder: "Enter Leasing (EN)",
      validation: { required: "Leasing (EN) is required" },
    },
    {
      fieldName: "Leasing (MS)",
      fieldValue: "field_leasing_ms",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_ms",
      formType: "input",
      label: "Leasing (MS)",
      placeholder: "Enter Leasing (MS)",
      // validation: { required: "Leasing (MS) is required" },
    },
    {
      fieldName: "Leasing (ZH)",
      fieldValue: "field_leasing_zh",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_zh",
      formType: "input",
      label: "Leasing (ZH)",
      placeholder: "Enter Leasing (ZH)",
      // validation: { required: "Leasing (ZH) is required" },
    },
    {
      fieldName: "Tenancy Link (EN)",
      fieldValue: "field_tenancy_link_en",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_en",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (EN)",
      placeholder: "Enter Tenancy Link (EN)",
      validation: { required: "Tenancy Link (EN) is required" },
    },
    {
      fieldName: "Tenancy Link (MS)",
      fieldValue: "field_tenancy_link_ms",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_ms",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (MS)",
      placeholder: "Enter Tenancy Link (MS)",
      // validation: { required: "Tenancy Link (MS) is required" },
    },
    {
      fieldName: "Tenancy Link (ZH)",
      fieldValue: "field_tenancy_link_zh",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_zh",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (ZH)",
      placeholder: "Enter Tenancy Link (ZH)",
      // validation: { required: "Tenancy Link (ZH) is required" },
    },
    {
      fieldName: "Tender Priority (EN)",
      fieldValue: "field_tender_priority",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority",
      formType: "select",
      label: "Tender Priority (EN)",
      placeholder: "Enter Tender Priority (EN)",
      validation: { required: "Tender Priority (EN) is required" },
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
    },
    {
      fieldName: "Tender Priority (MS)",
      fieldValue: "field_tender_priority_ms",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_ms",
      formType: "select",
      label: "Tender Priority (MS)",
      placeholder: "Enter Tender Priority (MS)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (MS) is required" },
    },
    {
      fieldName: "Tender Priority (ZH)",
      fieldValue: "field_tender_priority_zh",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_zh",
      formType: "select",
      label: "Tender Priority (ZH)",
      placeholder: "Enter Tender Priority (ZH)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (ZH) is required" },
    },
    {
      fieldName: "Opening Date",
      fieldValue: "field_opening_date",
      className: "col-span-6",
      type: "text",
      name: "field_opening_date",
      formType: "dateTime",
      label: "Opening Date",
      placeholder: "Select Opening Date",
      validation: { required: "Opening Date is required" },
    },
    {
      fieldName: "Closing Date",
      fieldValue: "field_closing_date",
      className: "col-span-6",
      type: "text",
      name: "field_closing_date",
      formType: "dateTime",
      label: "Closing Date",
      placeholder: "Select Closing Date",
      validation: { required: "Closing Date is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
    // {
    //   fieldName: "Page Name (EN)",
    //   fieldValue: "field_pagename_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_pagename_en",
    //   formType: "input",
    //   label: "Page Name (EN)",
    //   placeholder: "Enter Page Name (EN)",
    //   validation: { required: "Page Name (EN) is required" },
    // },
   
  ],
  foodAndBeverageList: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_leasing_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_leasing_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_tender_category_ms",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_tender_category_zh",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "OMD Number (EN)",
      fieldValue: "field_omd_number_en",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_en",
      formType: "input",
      label: "OMD Number (EN)",
      placeholder: "Enter OMD Number (EN)",
      validation: { required: "OMD Number (EN) is required" },
    },
    {
      fieldName: "OMD Number (MS)",
      fieldValue: "field_omd_number_ms",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_ms",
      formType: "input",
      label: "OMD Number (MS)",
      placeholder: "Enter OMD Number (MS)",
      // validation: { required: "OMD Number (MS) is required" },
    },
    {
      fieldName: "OMD Number (ZH)",
      fieldValue: "field_omd_number_zh",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_zh",
      formType: "input",
      label: "OMD Number (ZH)",
      placeholder: "Enter OMD Number (ZH)",
      // validation: { required: "OMD Number (ZH) is required" },
    },
    {
      fieldName: "Airport (EN)",
      fieldValue: "field_airport_en",
      className: "col-span-6",
      type: "text",
      name: "field_airport_en",
      formType: "input",
      label: "Airport (EN)",
      placeholder: "Enter Airport (EN)",
      validation: { required: "Airport (EN) is required" },
    },
    {
      fieldName: "Airport (MS)",
      fieldValue: "field_airport_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airport_ms",
      formType: "input",
      label: "Airport (MS)",
      placeholder: "Enter Airport (MS)",
      // validation: { required: "Airport (MS) is required" },
    },
    {
      fieldName: "Airport (ZH)",
      fieldValue: "field_airport_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airport_zh",
      formType: "input",
      label: "Airport (ZH)",
      placeholder: "Enter Airport (ZH)",
      // validation: { required: "Airport (ZH) is required" },
    },
    {
      fieldName: "Leasing (EN)",
      fieldValue: "field_leasing_en",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_en",
      formType: "input",
      label: "Leasing (EN)",
      placeholder: "Enter Leasing (EN)",
      validation: { required: "Leasing (EN) is required" },
    },
    {
      fieldName: "Leasing (MS)",
      fieldValue: "field_leasing_ms",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_ms",
      formType: "input",
      label: "Leasing (MS)",
      placeholder: "Enter Leasing (MS)",
      // validation: { required: "Leasing (MS) is required" },
    },
    {
      fieldName: "Leasing (ZH)",
      fieldValue: "field_leasing_zh",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_zh",
      formType: "input",
      label: "Leasing (ZH)",
      placeholder: "Enter Leasing (ZH)",
      // validation: { required: "Leasing (ZH) is required" },
    },
    {
      fieldName: "Tenancy Link (EN)",
      fieldValue: "field_tenancy_link_en",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_en",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (EN)",
      placeholder: "Enter Tenancy Link (EN)",
      validation: { required: "Tenancy Link (EN) is required" },
    },
    {
      fieldName: "Tenancy Link (MS)",
      fieldValue: "field_tenancy_link_ms",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_ms",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (MS)",
      placeholder: "Enter Tenancy Link (MS)",
      // validation: { required: "Tenancy Link (MS) is required" },
    },
    {
      fieldName: "Tenancy Link (ZH)",
      fieldValue: "field_tenancy_link_zh",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_zh",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (ZH)",
      placeholder: "Enter Tenancy Link (ZH)",
      // validation: { required: "Tenancy Link (ZH) is required" },
    },
    {
      fieldName: "Tender Priority (EN)",
      fieldValue: "field_tender_priority",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority",
      formType: "select",
      label: "Tender Priority (EN)",
      placeholder: "Enter Tender Priority (EN)",
      validation: { required: "Tender Priority (EN) is required" },
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
    },
    {
      fieldName: "Tender Priority (MS)",
      fieldValue: "field_tender_priority_ms",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_ms",
      formType: "select",
      label: "Tender Priority (MS)",
      placeholder: "Enter Tender Priority (MS)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (MS) is required" },
    },
    {
      fieldName: "Tender Priority (ZH)",
      fieldValue: "field_tender_priority_zh",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_zh",
      formType: "select",
      label: "Tender Priority (ZH)",
      placeholder: "Enter Tender Priority (ZH)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (ZH) is required" },
    },
    {
      fieldName: "Opening Date",
      fieldValue: "field_opening_date",
      className: "col-span-6",
      type: "text",
      name: "field_opening_date",
      formType: "dateTime",
      label: "Opening Date",
      placeholder: "Select Opening Date",
      validation: { required: "Opening Date is required" },
    },
    {
      fieldName: "Closing Date",
      fieldValue: "field_closing_date",
      className: "col-span-6",
      type: "text",
      name: "field_closing_date",
      formType: "dateTime",
      label: "Closing Date",
      placeholder: "Select Closing Date",
      validation: { required: "Closing Date is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
    // {
    //   fieldName: "Page Name (EN)",
    //   fieldValue: "field_pagename_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_pagename_en",
    //   formType: "input",
    //   label: "Page Name (EN)",
    //   placeholder: "Enter Page Name (EN)",
    //   validation: { required: "Page Name (EN) is required" },
    // },
   
  ],
  serviceOutletList: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_leasing_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_leasing_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_tender_category_ms",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_tender_category_zh",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "OMD Number (EN)",
      fieldValue: "field_omd_number_en",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_en",
      formType: "input",
      label: "OMD Number (EN)",
      placeholder: "Enter OMD Number (EN)",
      validation: { required: "OMD Number (EN) is required" },
    },
    {
      fieldName: "OMD Number (MS)",
      fieldValue: "field_omd_number_ms",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_ms",
      formType: "input",
      label: "OMD Number (MS)",
      placeholder: "Enter OMD Number (MS)",
      // validation: { required: "OMD Number (MS) is required" },
    },
    {
      fieldName: "OMD Number (ZH)",
      fieldValue: "field_omd_number_zh",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_zh",
      formType: "input",
      label: "OMD Number (ZH)",
      placeholder: "Enter OMD Number (ZH)",
      // validation: { required: "OMD Number (ZH) is required" },
    },
    {
      fieldName: "Airport (EN)",
      fieldValue: "field_airport_en",
      className: "col-span-6",
      type: "text",
      name: "field_airport_en",
      formType: "input",
      label: "Airport (EN)",
      placeholder: "Enter Airport (EN)",
      validation: { required: "Airport (EN) is required" },
    },
    {
      fieldName: "Airport (MS)",
      fieldValue: "field_airport_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airport_ms",
      formType: "input",
      label: "Airport (MS)",
      placeholder: "Enter Airport (MS)",
      // validation: { required: "Airport (MS) is required" },
    },
    {
      fieldName: "Airport (ZH)",
      fieldValue: "field_airport_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airport_zh",
      formType: "input",
      label: "Airport (ZH)",
      placeholder: "Enter Airport (ZH)",
      // validation: { required: "Airport (ZH) is required" },
    },
    {
      fieldName: "Leasing (EN)",
      fieldValue: "field_leasing_en",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_en",
      formType: "input",
      label: "Leasing (EN)",
      placeholder: "Enter Leasing (EN)",
      validation: { required: "Leasing (EN) is required" },
    },
    {
      fieldName: "Leasing (MS)",
      fieldValue: "field_leasing_ms",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_ms",
      formType: "input",
      label: "Leasing (MS)",
      placeholder: "Enter Leasing (MS)",
      // validation: { required: "Leasing (MS) is required" },
    },
    {
      fieldName: "Leasing (ZH)",
      fieldValue: "field_leasing_zh",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_zh",
      formType: "input",
      label: "Leasing (ZH)",
      placeholder: "Enter Leasing (ZH)",
      // validation: { required: "Leasing (ZH) is required" },
    },
    {
      fieldName: "Tenancy Link (EN)",
      fieldValue: "field_tenancy_link_en",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_en",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (EN)",
      placeholder: "Enter Tenancy Link (EN)",
      validation: { required: "Tenancy Link (EN) is required" },
    },
    {
      fieldName: "Tenancy Link (MS)",
      fieldValue: "field_tenancy_link_ms",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_ms",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (MS)",
      placeholder: "Enter Tenancy Link (MS)",
      // validation: { required: "Tenancy Link (MS) is required" },
    },
    {
      fieldName: "Tenancy Link (ZH)",
      fieldValue: "field_tenancy_link_zh",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_zh",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (ZH)",
      placeholder: "Enter Tenancy Link (ZH)",
      // validation: { required: "Tenancy Link (ZH) is required" },
    },
    {
      fieldName: "Tender Priority (EN)",
      fieldValue: "field_tender_priority",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority",
      formType: "select",
      label: "Tender Priority (EN)",
      placeholder: "Enter Tender Priority (EN)",
      validation: { required: "Tender Priority (EN) is required" },
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
    },
    {
      fieldName: "Tender Priority (MS)",
      fieldValue: "field_tender_priority_ms",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_ms",
      formType: "select",
      label: "Tender Priority (MS)",
      placeholder: "Enter Tender Priority (MS)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (MS) is required" },
    },
    {
      fieldName: "Tender Priority (ZH)",
      fieldValue: "field_tender_priority_zh",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_zh",
      formType: "select",
      label: "Tender Priority (ZH)",
      placeholder: "Enter Tender Priority (ZH)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (ZH) is required" },
    },
    {
      fieldName: "Opening Date",
      fieldValue: "field_opening_date",
      className: "col-span-6",
      type: "text",
      name: "field_opening_date",
      formType: "dateTime",
      label: "Opening Date",
      placeholder: "Select Opening Date",
      validation: { required: "Opening Date is required" },
    },
    {
      fieldName: "Closing Date",
      fieldValue: "field_closing_date",
      className: "col-span-6",
      type: "text",
      name: "field_closing_date",
      formType: "dateTime",
      label: "Closing Date",
      placeholder: "Select Closing Date",
      validation: { required: "Closing Date is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
    // {
    //   fieldName: "Page Name (EN)",
    //   fieldValue: "field_pagename_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_pagename_en",
    //   formType: "input",
    //   label: "Page Name (EN)",
    //   placeholder: "Enter Page Name (EN)",
    //   validation: { required: "Page Name (EN) is required" },
    // },
   
  ],
  othersList: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_leasing_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_leasing_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_tender_category_ms",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_tender_category_zh",
      className: "col-span-6",
      type: "text",
      name: "field_tender_category_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "OMD Number (EN)",
      fieldValue: "field_omd_number_en",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_en",
      formType: "input",
      label: "OMD Number (EN)",
      placeholder: "Enter OMD Number (EN)",
      validation: { required: "OMD Number (EN) is required" },
    },
    {
      fieldName: "OMD Number (MS)",
      fieldValue: "field_omd_number_ms",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_ms",
      formType: "input",
      label: "OMD Number (MS)",
      placeholder: "Enter OMD Number (MS)",
      // validation: { required: "OMD Number (MS) is required" },
    },
    {
      fieldName: "OMD Number (ZH)",
      fieldValue: "field_omd_number_zh",
      className: "col-span-6",
      type: "text",
      name: "field_omd_number_zh",
      formType: "input",
      label: "OMD Number (ZH)",
      placeholder: "Enter OMD Number (ZH)",
      // validation: { required: "OMD Number (ZH) is required" },
    },
    {
      fieldName: "Airport (EN)",
      fieldValue: "field_airport_en",
      className: "col-span-6",
      type: "text",
      name: "field_airport_en",
      formType: "input",
      label: "Airport (EN)",
      placeholder: "Enter Airport (EN)",
      validation: { required: "Airport (EN) is required" },
    },
    {
      fieldName: "Airport (MS)",
      fieldValue: "field_airport_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airport_ms",
      formType: "input",
      label: "Airport (MS)",
      placeholder: "Enter Airport (MS)",
      // validation: { required: "Airport (MS) is required" },
    },
    {
      fieldName: "Airport (ZH)",
      fieldValue: "field_airport_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airport_zh",
      formType: "input",
      label: "Airport (ZH)",
      placeholder: "Enter Airport (ZH)",
      // validation: { required: "Airport (ZH) is required" },
    },
    {
      fieldName: "Leasing (EN)",
      fieldValue: "field_leasing_en",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_en",
      formType: "input",
      label: "Leasing (EN)",
      placeholder: "Enter Leasing (EN)",
      validation: { required: "Leasing (EN) is required" },
    },
    {
      fieldName: "Leasing (MS)",
      fieldValue: "field_leasing_ms",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_ms",
      formType: "input",
      label: "Leasing (MS)",
      placeholder: "Enter Leasing (MS)",
      // validation: { required: "Leasing (MS) is required" },
    },
    {
      fieldName: "Leasing (ZH)",
      fieldValue: "field_leasing_zh",
      className: "col-span-6",
      type: "text",
      name: "field_leasing_zh",
      formType: "input",
      label: "Leasing (ZH)",
      placeholder: "Enter Leasing (ZH)",
      // validation: { required: "Leasing (ZH) is required" },
    },
    {
      fieldName: "Tenancy Link (EN)",
      fieldValue: "field_tenancy_link_en",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_en",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (EN)",
      placeholder: "Enter Tenancy Link (EN)",
      validation: { required: "Tenancy Link (EN) is required" },
    },
    {
      fieldName: "Tenancy Link (MS)",
      fieldValue: "field_tenancy_link_ms",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_ms",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (MS)",
      placeholder: "Enter Tenancy Link (MS)",
      // validation: { required: "Tenancy Link (MS) is required" },
    },
    {
      fieldName: "Tenancy Link (ZH)",
      fieldValue: "field_tenancy_link_zh",
      className: "col-span-6",
      type: "pdf",
      name: "field_tenancy_link_zh",
      formType: "file",
      usedFileType: ".pdf",
      label: "Tenancy Link (ZH)",
      placeholder: "Enter Tenancy Link (ZH)",
      // validation: { required: "Tenancy Link (ZH) is required" },
    },
    {
      fieldName: "Tender Priority (EN)",
      fieldValue: "field_tender_priority",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority",
      formType: "select",
      label: "Tender Priority (EN)",
      placeholder: "Enter Tender Priority (EN)",
      validation: { required: "Tender Priority (EN) is required" },
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
    },
    {
      fieldName: "Tender Priority (MS)",
      fieldValue: "field_tender_priority_ms",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_ms",
      formType: "select",
      label: "Tender Priority (MS)",
      placeholder: "Enter Tender Priority (MS)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (MS) is required" },
    },
    {
      fieldName: "Tender Priority (ZH)",
      fieldValue: "field_tender_priority_zh",
      className: "col-span-6",
      type: "select",
      name: "field_tender_priority_zh",
      formType: "select",
      label: "Tender Priority (ZH)",
      placeholder: "Enter Tender Priority (ZH)",
      options: [
        {
          label: 'Fast Track',
          value: 'Fast Track'
        },
        {
          label: 'Standard',
          value: 'Standard'
        }
      ]
      // validation: { required: "Tender Priority (ZH) is required" },
    },
    {
      fieldName: "Opening Date",
      fieldValue: "field_opening_date",
      className: "col-span-6",
      type: "text",
      name: "field_opening_date",
      formType: "dateTime",
      label: "Opening Date",
      placeholder: "Select Opening Date",
      validation: { required: "Opening Date is required" },
    },
    {
      fieldName: "Closing Date",
      fieldValue: "field_closing_date",
      className: "col-span-6",
      type: "text",
      name: "field_closing_date",
      formType: "dateTime",
      label: "Closing Date",
      placeholder: "Select Closing Date",
      validation: { required: "Closing Date is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
    // {
    //   fieldName: "Page Name (EN)",
    //   fieldValue: "field_pagename_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_pagename_en",
    //   formType: "input",
    //   label: "Page Name (EN)",
    //   placeholder: "Enter Page Name (EN)",
    //   validation: { required: "Page Name (EN) is required" },
    // },
   
  ],
  commercialLeasingOpportunitiesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  commercialLeasingOpportunitiesNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english.data.nextPage.name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay.data.nextPage.name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
      //   parseField: "field_content_malay",
      //   className: "col-span-6",
      //   type: "content",
    //   name: "field_content_malay.data.nextPage.link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter content for Next Page Link (MS)",
    //   // validation: { required: "Content for Next Page Link (MS) is required" },
    // },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin.data.nextPage.name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english.data.nextPage.link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: { required: "Content for Next Page Link is required",  validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
}  },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin.data.nextPage.link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter content for Next Page Link (ZH)",
    //   // validation: { required: "Content for Next Page Link (ZH) is required" },
    // },
  ],
  airlineServicesFacilities: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_airline_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_airline_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_airline_image",
      className: "col-span-6",
      type: "image",
      name: "field_airline_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_airlines_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_airlines_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_airline_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airline_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_airline_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airline_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    // {
    //   fieldName: "Page (EN)",
    //   fieldValue: "field_airline_page_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_airline_page_en",
    //   formType: "input",
    //   label: "Page (EN)",
    //   placeholder: "Enter Page (EN)",
    //   validation: { required: "Page (EN) is required" },
    // },
    // {
    //   fieldName: "Page (MS)",
    //   fieldValue: "field_airline_page_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_airline_page_ms",
    //   formType: "input",
    //   label: "Page (MS)",
    //   placeholder: "Enter Page (MS)",
    //   // validation: { required: "Page (MS) is required" },
    // },
    // {
    //   fieldName: "Page (ZH)",
    //   fieldValue: "field_airline_page_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_airline_page_zh",
    //   formType: "input",
    //   label: "Page (ZH)",
    //   placeholder: "Enter Page (ZH)",
    //   // validation: { required: "Page (ZH) is required" },
    // },
    {
      fieldName: "Large",
      fieldValue: "field_islarge",
      className: "col-span-12",
      type: "checkbox",
      name: "field_islarge",
      formType: "checkbox",
      label: "Large",
      placeholder: "Enter Large",
      // validation: { required: "Page (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
   
  ],
  airlineServicesFacilitiesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
};
